import React from 'react';

interface IConfig {
  [key: string]: any;
}

/**使用React的useContext钩子来获取ConfigurationContext中的用户数据
 * 放置项目中的通用参数，如下拉选项，列表值的枚举等
 *
 * @returns {{
 * rightStatusMap:object,
 * setRightStatusMap:()=>void,
 *
 * }}
 */

const ConfigurationContext = React.createContext<IConfig>({});

export default ConfigurationContext;
